const $ = require('jquery');
import run from '../../../utilities/run';
import render from "../../../utilities/render";


import ManageBusinessLogic from './manageBusinessLogic.js';

// NOTE - choose target (id or unique class) where you want this to
const targetSelector = "#user-manage-page-id";

run(targetSelector, (outerEl)=>{
 attachManagePage(outerEl);
});

function attachManagePage(outerEl){
  const manageTeamMembersLogic = new ManageBusinessLogic(outerEl);
  manageTeamMembersLogic.init();
};



// WEBPACK FOOTER //
// ./src/pages/teamMembers/manage/manage.js